import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { adminApi } from "../lib/api";
import { useSeo } from "../components/site/Layout";
import { euros } from "../data/site";
import { fmtDateTime } from "./AdminLayout";

export const PAY_STATUSES = ["en attente", "payé", "échoué", "expiré", "annulé"];
const COLORS = { "en attente": "bg-blue-100 text-blue-900", payé: "bg-green-100 text-green-900", échoué: "bg-red-100 text-red-900", expiré: "bg-slate-200 text-slate-800", annulé: "bg-slate-200 text-slate-700" };
export const PayBadge = ({ status, testid }) => <span data-testid={testid} className={`inline-flex rounded-full px-3 py-1 text-sm font-semibold ${COLORS[status]}`}>{status}</span>;

export default function AdminPayments() {
  useSeo("Paiements — admin");
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const [rows, setRows] = useState(null);
  useEffect(() => { adminApi.get("/payments", { params: { status: status || undefined } }).then((r) => setRows(r.data)); }, [status]);
  const total = (rows || []).filter((r) => r.status === "payé").reduce((s, r) => s + r.amount_cents, 0);
  return (
    <div data-testid="admin-payments">
      <h1 className="text-3xl sm:text-4xl">Paiements</h1>
      <div className="mt-6 flex flex-wrap items-center gap-4">
        <label className="flex items-center gap-2 font-semibold text-navy">Statut
          <select className="field-input py-2 w-auto" value={status} onChange={(e) => setParams(e.target.value ? { status: e.target.value } : {})} data-testid="payments-filter-status">
            <option value="">Tous</option>{PAY_STATUSES.map((s) => <option key={s}>{s}</option>)}
          </select>
        </label>
        <p className="text-slate-600">Total payé (liste affichée) : <strong className="text-navy" data-testid="payments-list-paid-total">{euros(total)}</strong></p>
      </div>
      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full min-w-[880px] text-left">
          <thead className="bg-slate-100 text-slate-700 text-sm uppercase tracking-wider">
            <tr><th className="p-4">Date</th><th className="p-4">Client</th><th className="p-4">Type</th><th className="p-4">Référence</th><th className="p-4">Objet</th><th className="p-4 text-right">Montant</th><th className="p-4">Statut</th></tr>
          </thead>
          <tbody>
            {rows?.map((p) => (
              <tr key={p.id} className="border-t border-slate-100" data-testid={`payment-row-${p.id}`}>
                <td className="p-4 text-sm text-slate-600 whitespace-nowrap">{fmtDateTime(p.created_at)}{p.paid_at && <div className="text-green-800">payé le {fmtDateTime(p.paid_at)}</div>}</td>
                <td className="p-4"><span className="font-semibold">{p.client_name}</span><div className="text-sm text-slate-600">{p.email}</div></td>
                <td className="p-4" data-testid={`payment-type-${p.id}`}>{p.type}</td>
                <td className="p-4 font-mono text-sm">{p.reference}</td>
                <td className="p-4 text-sm">{p.description}</td>
                <td className="p-4 text-right font-semibold whitespace-nowrap" data-testid={`payment-amount-${p.id}`}>{euros(p.amount_cents)}</td>
                <td className="p-4"><PayBadge status={p.status} testid={`payment-status-${p.id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows && !rows.length && <p className="p-6 text-slate-600" data-testid="payments-empty">Aucun paiement.</p>}
        {!rows && <p className="p-6 text-slate-600">Chargement…</p>}
      </div>
    </div>
  );
}
